import * as Yup from "yup";

const mensagemPersonalizadaValidator = Yup.object().shape({
  contexto: Yup.string().required("Contexto"),
  mensagem: Yup.string().required("Mensagem"),
  variaveis: Yup.array().of(Yup.string()).nullable().optional(),
  ativado: Yup.boolean().nullable().optional(),
});

export default mensagemPersonalizadaValidator;
